import { useState, useEffect, createContext, useContext } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const defaults = { aktuelles_enabled: true, objekte_enabled: true };

const SettingsContext = createContext(defaults);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(defaults);

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
